export const parseAuthAPIResponse = (response) => {
    const parsedResponse = JSON.parse(response);
    if (parsedResponse.success || parsedResponse.Success) {
        return parsedResponse.jwt || parsedResponse.Jwt;
    }
    throw new Error(parsedResponse.message || parsedResponse.Message);
};
//# sourceMappingURL=parseAuthAPIResponse.js.map